import { Component, DoCheck, EventEmitter, Input, Output } from '@angular/core';
import { TShare } from 'src/app/project/modules/share/share.model';
import { getDisabledUserManagementTooltipText } from 'src/app/project/modules/user-management/user-management-table-cells/utils/get-disabled-user-management-cell-tooltip-text';

@Component({
    selector: 'pp-account-user-modal-shares-list-share-flags',
    templateUrl: './account-user-modal-shares-list-share-flags.component.html',
    styleUrl: './account-user-modal-shares-list-share-flags.component.scss',
    standalone: false
})
export class AccountUserModalSharesListShareFlagsComponent implements DoCheck {
  @Input() ppShare: TShare;
  @Output() ppShareChange = new EventEmitter<TShare>();
  @Input() ppDisabled: boolean;
  editPermission: boolean;
  disabledTooltipText: string;

  ngDoCheck(): void {
    this.setEditPermission();
  }

  private setEditPermission(): void {
    this.editPermission = this.ppShare.advancedAccessLevels.flags.permission.edit;
    this.disabledTooltipText = getDisabledUserManagementTooltipText(this.ppShare.shareOption);
  }

  changeEditPermission(): void {
    this.editPermission = !this.editPermission;

    const newShare = { ...this.ppShare };
    newShare.advancedAccessLevels.flags.permission.edit = this.editPermission;

    this.ppShareChange.emit(newShare);
  }
}
